var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy"},[_c('span',[_vm._v(_vm._s(_vm.$t('message.checkout.policy.prefix')))]),_c('span',{staticClass:"btn",on:{"click":_vm.viewPolicy}},[_vm._v(_vm._s(_vm.$t('message.checkout.privacy')))]),_c('span',[_vm._v(_vm._s(_vm.$t('message.checkout.policy.suffix')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }